/**
 * Canvas data model — kept tier-agnostic so Builders/Designers reuse it.
 * Spec ref: §15.6 SceneObject schema.
 */

export type ShapeType = 'cube' | 'cylinder' | 'sphere' | 'cone' | 'disc' | 'slab';

export interface ShapeRef {
  /** Stable identifier — what gets persisted in scene_json. */
  id: string;
  type: ShapeType;
  /** Human-readable label (used by Builders+ tier; hidden from Explorers UI). */
  label: string;
  /** Background color for the panel thumbnail (color-coded per spec §3.1). */
  color: string;
  /** Default geometry parameters. */
  params: ShapeParams;
}

export interface ShapeParams {
  width: number; // mm
  height: number; // mm
  depth: number; // mm
  radius: number; // mm
}

export interface SceneObject {
  id: string;
  shapeRefId: string;
  position: [number, number, number]; // mm
  scale: number; // uniform scale for Explorers
  /** Future: rotation triplet. Always [0,0,0] in Explorers. */
  rotation: [number, number, number];
  /** Drives "set as hole" in Builders+; always false in Explorers. */
  isHole: boolean;
}

export type Op =
  | { type: 'add'; after: SceneObject }
  | { type: 'delete'; before: SceneObject }
  | { type: 'move'; id: string; before: SceneObject['position']; after: SceneObject['position'] }
  | { type: 'scale'; id: string; before: number; after: number };

export const EXPLORERS_GRID_MM = 5;

/** Workplane bounds in mm — kid can't move shapes outside. */
export const WORKPLANE_HALF_MM = 80;
